import styled from 'styled-components';

export const ErrorMessage = styled.div`
    color: ${props => props.theme.colors.red};
    font-size: 12px;
    margin-top: 4px;
    width: 100%;
`;

